// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Menu":"bgx_a bhm_h","Menu__offsetParent":"bgx_b bhm_bj","Menu__trigger--shadowed":"bgx_c"};